import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, MessageSquare, Sparkles } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
const features = [{
  icon: PenTool,
  title: 'IA escribe por ti',
  description: 'Genera textos persuasivos y correos electrónicos sin necesidad de ser un experto en redacción.'
}, {
  icon: MessageSquare,
  title: 'IA responde por ti',
  description: 'Automatiza la atención y el seguimiento para que tu negocio opere 24/7 sin tu intervención manual.'
}, {
  icon: Sparkles,
  title: 'IA crea contenido por ti',
  description: 'Produce material visual y escrito de alta calidad que atrae clientes sin mostrar tu rostro.'
}];
export function UniqueMechanism() {
  return <section className="bg-[#0a0a0a] py-24 relative overflow-hidden" data-id="element-151">
      <div className="absolute top-0 left-0 w-full text-[#d4a437]/10" data-id="element-152">
        <WaveDivider className="h-8 md:h-16" data-id="element-153" />
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10 mt-8" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-156">
            Generación de{' '}
            <span className="text-[#d4a437] font-serif italic" data-id="element-157">
              Ingresos Invisibles
            </span>
          </h2>
          <p className="text-lg md:text-xl text-neutral-300 max-w-3xl mx-auto leading-relaxed" data-id="element-158">
            Affiliate Wave ha creado el ecosistema perfecto. A través de la
            comunidad oficial de Gus Sevilla, aprenderás a usar el marketing de
            afiliados bajo la lógica del "Operador Anónimo".
          </p>
          <p className="text-lg md:text-xl text-neutral-300 max-w-3xl mx-auto leading-relaxed mt-4" data-id="element-159">
            Utilizamos la IA (Inteligencia Artificial) como tu escudo y tu voz.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-160">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111] border border-[#d4a437]/20 rounded-2xl p-8 text-center relative overflow-hidden group" data-id="element-161">
              <div className="absolute inset-0 bg-gradient-to-b from-[#d4a437]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-162"></div>
              <div className="relative z-10 flex flex-col items-center" data-id="element-163">
                <div className="w-16 h-16 rounded-full bg-[#d4a437]/10 flex items-center justify-center mb-6" data-id="element-164">
                  <feature.icon className="w-8 h-8 text-[#d4a437]" data-id="element-165" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-166">
                  {feature.title}
                </h3>
                <p className="text-neutral-400 leading-relaxed" data-id="element-167">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-168">
          <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-169">
            Tú te mantienes como el{' '}
            <span className="text-[#d4a437]" data-id="element-170">
              arquitecto detrás de la pantalla
            </span>
            , construyendo un negocio legal, ético y altamente rentable en
            dólares sin salir de tu sala.
          </h3>
        </motion.div>
      </div>
    </section>;
}